"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputComponent = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class InputComponent extends gotti_1.Component {
    constructor(inputObj) {
        super(Constants_1.SYSTEMS.INPUT);
        this.playerInput = inputObj;
    }
}
exports.InputComponent = InputComponent;
//# sourceMappingURL=module.js.map